import { createSlice } from '@reduxjs/toolkit';
import {
  ValidationSpecialistQuestionnairesState,
  GetEDTFSchemasFetchAction,
  GetEDTFSchemasSuccessAction,
  UpdateEDTFDataAction,
  UpdateUploadFormAction,
  UpdateUploadFormSuccessAction
} from './ValidationSpecialistQuestionnaires.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';
import { UploadFormData } from '@dynamika-shared/types/validationSpecialist';

const initialState: ValidationSpecialistQuestionnairesState = {
  edtfData: null,
  loading: false,
  error: undefined,
  selectedSchema: null,
  schemas: [],
  schemasLoading: false,
  schemasError: undefined,
  needUpdateUploads: false,
};

const { actReject, actReq, actResolve, act } =
  makeActionCreator<ValidationSpecialistQuestionnairesState>();

export const ValidationSpecialistQuestionnairesSlice = createSlice({
  name: 'ValidationSpecialistQuestionnaires',
  initialState,
  reducers: {
    getEDTFSchemas: act<GetEDTFSchemasFetchAction['payload']>(() => ({
      schemas: [],
      selectedSchema: null,
      edtfData: null,
      schemasError: undefined,
      schemasLoading: true,
    })),
    getEDTFSchemasSuccess: act<GetEDTFSchemasSuccessAction['payload']>(schemas => ({
      schemas,
      schemasLoading: false,
      schemasError: undefined,
    })),
    getEDTFSchemasFailure: act<Error>(schemasError => ({
      schemas: [],
      schemasError,
      schemasLoading: false,
    })),

    updateParticipantForm: actReq<UpdateUploadFormAction['payload']>('loading'),
    updateParticipantFormSuccess: act<UpdateUploadFormSuccessAction['payload']>((s, action) => {
      return {
        loading: false,
        edtfData: action.edtfData,
        needUpdateUploads: true,
      };
    }),
    updateParticipantFormFailure: act<Error>(error => ({
      error,
    })),

    updateEdtfData: actResolve<UpdateEDTFDataAction['payload']>('edtfData'),
    updateEdtfDataFailure: actReject(),

    selectEDTFSchema: act<UploadFormData>(selectedSchema => ({
      selectedSchema,
    })),

    setNeedUpdateUploads: act<boolean>(needUpdateUploads => ({
      needUpdateUploads,
    })),
  },
});

export const {
  getEDTFSchemas,
  getEDTFSchemasSuccess,
  getEDTFSchemasFailure,
  updateParticipantForm,
  updateParticipantFormSuccess,
  updateParticipantFormFailure,
  updateEdtfData,
  updateEdtfDataFailure,
  selectEDTFSchema,
  setNeedUpdateUploads,
} = ValidationSpecialistQuestionnairesSlice.actions;

export const actions = {
  ...ValidationSpecialistQuestionnairesSlice.actions,
};

export const useValidationSpecialistQuestionnairesSlice = createSliceHook(
  ValidationSpecialistQuestionnairesSlice.name,
  actions
);

export const selectValidationSpecialistQuestionnairesState = createSelector(ValidationSpecialistQuestionnairesSlice.name);
